import {BaseWidgetProps} from '../../../widget-container';
import {RenderHtml} from '../../../../common/render-html.comp';
import {Icon, iconsMap} from '../../../../common/icons/icon.comp';
// import {translate} from '../../../../common/translate';
import * as React from 'react';
import {Article, ArticleType} from '@wix/answers-api';

export interface ResolutionProps {
	article: Article;
	baseConfig: BaseWidgetProps;
}

export class Resolution extends React.Component<ResolutionProps, any> {

	render () {
		const article = this.props.article;
		const resolution = article.resolution;
		const translate = this.props.baseConfig.translate;
		const resolutionComp = (
			<div className={`resolution-content resolution-${resolution}`}>
				<Icon className='resolution-icon' icon={(iconsMap as any)[`resolution${resolution}`]} />
				<span className='resolution-label'>
					<RenderHtml html={translate(`widget-ng.article-resolution.${resolution}`)}/>
				</span>
			</div>
		);

		return article.type === ArticleType.FEATURE_REQUEST ||
		article.type === ArticleType.KNOWN_ISSUE ?
		(
			<div className='resolution'>{resolutionComp}</div>
		) :
		null;
	}
}
